import React from 'react';

import { LicenseFilter } from './filters';

const DrawerLicensePanel = () => <LicenseFilter />;

export default DrawerLicensePanel;
